export default __webpack_public_path__ + "static/B0285-bc1c4245c0a581e90734a6a4bd52d2cc.png";